import { Button } from "@/components/ui/button";
import { FormField } from "@/components/ui/form-field";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { useForm, Link } from "@inertiajs/react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

type LoginForm = Record<string, any> & {
  user: {
    email: string;
    password: string;
    remember: boolean;
  };
};
export default function LoginForm() {
  const { data, setData, post, processing, errors } = useForm<LoginForm>({
    user: {
      email: "",
      password: "",
      remember: false,
    },
  });

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    post("/login");
  };

  return (
    <AuthLayout title="Sign In" description="Access your racing dashboard">
      <form onSubmit={submit}>
        <div className="flex flex-col gap-6">
          {/* Show authentication form errors (from Inertia form errors, not flash) */}
          {errors && Object.keys(errors).length > 0 && (
            <Alert variant="destructive" className="bg-red-50">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                {errors.message || "Invalid email or password."}
              </AlertDescription>
            </Alert>
          )}

          <FormField
            id="email"
            label="Email Address"
            type="email"
            placeholder="your@email.com"
            value={data.user.email}
            onChange={(value) => setData("user.email", value)}
            required
            autoComplete="email"
          />

          <FormField
            id="password"
            label="Password"
            type="password"
            placeholder="••••••••"
            value={data.user.password}
            onChange={(value) => setData("user.password", value)}
            required
            autoComplete="current-password"
            rightElement={
              <Link
                href="/forgot_password"
                className="inline-block text-sm text-orange-600 hover:text-orange-700 font-medium hover:underline"
              >
                Forgot password?
              </Link>
            }
          />

          <div className="flex flex-col gap-3 pt-2">
            <Button
              type="submit"
              disabled={processing}
              variant="racing"
              size="lg"
              className="w-full shadow-xl"
            >
              {processing ? "Signing In..." : "Sign In"}
            </Button>
          </div>
        </div>
        <div className="mt-6 text-center text-sm">
          <span className="text-gray-600">New to Timing Tower?</span>{" "}
          <Link
            href="/register"
            className="text-orange-600 hover:text-orange-700 font-bold hover:underline"
          >
            Create Account
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
